class Logger {
  log(level, ...args) {
    switch (level) {
      case 'info':
        console.info(...args)
        break
      case 'warn':
        console.warn(...args)
        break
      case 'error':
        console.error(...args)
        break
      default:
        console.info(...args)
        break
    }
  }

  info(...args) {
    this.log('info', ...args)
  }

  warn(...args) {
    this.log('warn', ...args)
  }

  error(...args) {
    this.log('error', ...args)
  }
}

const logger = new Logger()

export default logger
